<template>
  <div v-if="vehicle && vehicle.id">
    <modal-component
      v-if="edit"
      v-model="modal.editVehicle.active"
    >
      <div slot="title">{{ modal.editVehicle.title }}</div>
      <edit-vehicle
        :inModal="true"
        :vehicleID="editVehicleID"
        :createAlert="false"
        @updated="closeCreateVehicleModal"
      ></edit-vehicle>
    </modal-component>


    <div class="flex items-center">
      <div class="w-1/4 self-stretch flex items-center border-r border-theme-200 light:border-theme-600" v-if="hasImage">
        <img
          class="px-1 align-middle"
          @error="onImageLoadFailure($event)"
          v-if="'/assets/images/vehicle-logos/' + $options.filters.kebabCase(vehicle.make) + '.png'"
          :src="'/assets/images/vehicle-logos/' + $options.filters.kebabCase(vehicle.make) + '.png'"
        >
      </div>
      <div class="w-3/4 pl-2">
        <router-link v-if="linkToVehicle" :to="'/vehicle/details/' + vehicle.id" class="leading-tight">
          <p class="text-xs">#{{ vehicle.id }}</p>
          <p class="text-2xl font-bold text-link">
            {{ vehicle.model }}
            <sup class="font-normal text-xs ml-1">
              <i class="fas fa-link"></i>
            </sup>
          </p>
          <p class="font-bold">{{ vehicle.make }}</p>
        </router-link>
        <template v-else>
          <p class="text-xs">#{{ vehicle.id }}</p>
          <p class="text-2xl font-bold leading-none">
            {{ vehicle.model }}
          </p>
          <p class="font-bold">{{ vehicle.make }}</p>
        </template>
      </div>
    </div>

    <table class="table table-small">
      <tbody>
        <tr>
          <td class="font-bold">Odometer reading:</td>
          <td>
            {{ vehicle.odometer_reading }} {{ config.speedUnits.filter(su => su.unit === vehicle.odometer_unit)[0].short }}
          </td>
        </tr>
        <tr>
          <td class="font-bold">Engine hours</td>
          <td>{{ vehicle.engine_hours }}</td>
        </tr>
        <tr>
          <td class="font-bold">Plate numbers:</td>
          <td>{{ vehicle.plate_numbers }}</td>
        </tr>
        <tr>
          <td class="font-bold">Model year:</td>
          <td>{{ vehicle.model_year }}</td>
        </tr>
        <tr>
          <td class="font-bold">VIN:</td>
          <td>{{ vehicle.vin }}</td>
        </tr>
        <tr>
          <td class="font-bold">Registration date</td>
          <td>{{ $moment(vehicle.registration_date).format('DD/MM/YYYY HH:mm') }}</td>
        </tr>
        <tr>
          <td class="font-bold">Manufacture date</td>
          <td>{{ $moment(vehicle.manufacture_date).format('DD/MM/YYYY HH:mm') }}</td>
        </tr>
        <tr>
          <td class="font-bold">Colour</td>
          <td>{{ vehicle.colour }}</td>
        </tr>
        <tr>
          <td class="font-bold">Fuel</td>
          <td>{{ vehicle.fuel }}</td>
        </tr>
        <tr>
          <td class="font-bold">Door plan</td>
          <td>{{ vehicle.door_plan }}</td>
        </tr>
        <tr>
          <td class="font-bold">Gear box</td>
          <td>{{ vehicle.gear_box }}</td>
        </tr>
        <tr>
          <td class="font-bold">Engine size</td>
          <td>{{ vehicle.engine_size }}</td>
        </tr>
        <tr>
          <td class="font-bold">Engine number</td>
          <td>{{ vehicle.engine_number }}</td>
        </tr>
        <tr>
          <td class="font-bold">Power</td>
          <td>{{ vehicle.power }}</td>
        </tr>
        <tr>
          <td class="font-bold">CO2 emission</td>
          <td>{{ vehicle.co2_emission }}</td>
        </tr>
        <tr>
          <td class="font-bold">Created at</td>
          <td>{{ $moment(vehicle.created_at).format('DD/MM/YYYY HH:mm') }}</td>
        </tr>
      </tbody>
    </table>

    <div class="text-center mt-8">
      <button
        v-if="edit"
        type="button"
        class="btn btn-blue py-2 px-3"
        @click="editVehicle"
      >
        <i class="fas fa-edit"></i>
        <span class="ml-2">Edit vehicle</span>
      </button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const EditVehicle = resolve => require(['@/components/pages/vehicles/Edit'], resolve)
const ModalComponent = resolve => require(['@/components/Modal'], resolve)

export default {
  props: {
    vehicle: Object,
    edit: Boolean,
    linkToVehicle: Boolean,
  },
  components: {
    EditVehicle,
    ModalComponent,
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  data() {
    return {
      editVehicleID: null,
      hasImage: true,
      modal: {
        editVehicle: {
          active: false,
          title: '',
        }
      },
    }
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.style.display = 'none'
      this.hasImage = false
    },
    editVehicle() {
      this.editVehicleID = this.vehicle.id
      // show modal
      this.modal.editVehicle.title = 'Edit vehicle'
      this.modal.editVehicle.active = true
    },
    closeCreateVehicleModal(vehicle) {
      // this.vehicle = Object.assign({}, this.vehicle, vehicle)
      // close modal
      this.modal.editVehicle.active = false

      // emit to parent
      this.$emit('updated', vehicle)
      // emit to bus
      this.$EventBus.$emit('vehicle.updated')
    },
  }
}
</script>
